import React, { useEffect, useState } from "react";
import { API, UPLOADS } from "./../../config/api";

export default function Viewmachine() {
  const [machines, setMachines] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedMachine, setSelectedMachine] = useState(null);
  const [paymentImage, setPaymentImage] = useState("");
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  /* NEW FILTER STATE */
  const [userIdFilter, setUserIdFilter] = useState("");

  useEffect(() => {
    fetchMachines();
  }, []);

  const fetchMachines = async () => {
    try {
      const res = await fetch(API.LIST_ACTIVE_MACHINES);

      const text = await res.text();

      console.log("API RESPONSE:", text);

      const data = JSON.parse(text);

      setMachines(Array.isArray(data) ? data : []);
    } catch (error) {
      console.log("Fetch Error:", error);
    }
  };

  const handleView = (machine) => {
    setSelectedMachine(machine);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  /* FILTERED DATA */
  const filteredMachines = machines.filter((item) => {
    if (!userIdFilter.trim()) return true;

    return String(item.user_id)
      .toLowerCase()
      .includes(userIdFilter.toLowerCase());
  });

  const handleStatus = async (status) => {
    if (status === "Rejected") {
      const confirmDelete = window.confirm(
        "Are you sure? Rejecting this machine will permanently delete it.",
      );
      if (!confirmDelete) return;
    }

    try {
      const formData = new FormData();
      formData.append("id", selectedMachine.id);

      if (status !== "Rejected") {
        formData.append("status", status);
      }

      const url =
        status === "Rejected" ? API.DELETE_MACHINE : API.UPDATE_MACHINE_STATUS;

      const res = await fetch(url, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      alert(data.message);
      setShowModal(false);
      fetchMachines();
    } catch (error) {
      console.log("Operation Error:", error);
    }
  };

  return (
    <div className="dashboard-content">
      <h2 className="machine-title">Active Machines Details</h2>

      {/* FILTER SECTION */}
      <div
        style={{
          marginBottom: "20px",
          display: "flex",
          gap: "12px",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <input
          id="userIdFilter"
          name="userIdFilter"
          type="text"
          placeholder="Filter by User ID"
          value={userIdFilter}
          onChange={(e) => setUserIdFilter(e.target.value)}
          style={{
            padding: "10px 14px",
            border: "1px solid #ddd",
            borderRadius: "8px",
            minWidth: "250px",
          }}
        />

        <button
          onClick={() => setUserIdFilter("")}
          style={{
            padding: "10px 18px",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            background: "#f1f5f9",
          }}
        >
          Clear Filter
        </button>
      </div>

      <div className="table-responsive">
        <table className="machine-table">
          <thead>
            <tr>
              <th>#</th>
              <th>U_Id</th>
              <th>Date</th>
              <th>Seller</th>
              <th>Machine Type</th>
              <th>Ads</th>
              <th>Active Date</th>
              <th>End Date</th>

              {/* <th>Location</th> */}
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredMachines.length > 0 ? (
              filteredMachines.map((item, index) => (
                <tr key={item.id}>
                  <td data-label="Id">{index + 1}</td>

                  <td data-label="User Id">{item.user_id}</td>
                  <td>
                    {" "}
                    <div className="fw-bold">
                      {new Date(item.created_at).toLocaleDateString()}
                    </div>
                    <div className="text-muted small">
                      {new Date(item.created_at).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </div>
                  </td>

                  <td>
                    <div className="fw-bold">{item.name}</div>
                    <div className="text-muted small">{item.phone}</div>
                  </td>

                  <td>
                    <div className="fw-bold">{item.machine_name}</div>
                    <div className="text-muted small">₹ {item.price}</div>
                  </td>

                  <td>
                    <div className="fw-bold">{item.show_ads_days} Days</div>
                    <div className="text-muted small">₹{item.ads_amount}</div>
                  </td>
                  <td>
                    {" "}
                    <div className="fw-bold">
                      {new Date(item.ads_start_date).toLocaleDateString()}
                    </div>
                    <div className="text-muted small">
                      {new Date(item.ads_start_date).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </div>
                  </td>
                  <td>
                    {" "}
                    <div className="fw-bold">
                      {new Date(item.ads_end_date).toLocaleDateString()}
                    </div>
                    <div className="text-muted small">
                      {new Date(item.ads_end_date).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </div>
                  </td>

                  {/* <td data-label="Location">{item.location}</td> */}

                  <td data-label="Status">
                    <span
                      className={
                        item.status === "Pending"
                          ? "status-pending"
                          : item.status === "Active"
                            ? "status-active"
                            : item.status === "Hide"
                              ? "status-hidden"
                              : "status-rejected"
                      }
                    >
                      {item.status}
                    </span>
                  </td>

                  <td>
                    <button
                      className="view-btn"
                      onClick={() => handleView(item)}
                    >
                      {/* <i className="bi bi-eye"> </i> */}
                      View
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="10"
                  style={{
                    textAlign: "center",
                    padding: "20px",
                  }}
                >
                  No machine found for this User ID.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* POPUP MODAL */}
      {showModal && selectedMachine && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-header">
              <h3>⚙ Machine Details</h3>
            </div>

            <div className="popup-grid">
              <div>
                <label>Machine Type</label>
                <p>{selectedMachine.machine_name}</p>
              </div>

              <div>
                <label>Left Side Head Type</label>
                <p>{selectedMachine.left_head_type}</p>
              </div>
              <div>
                <label>Right Side Head Type</label>
                <p>{selectedMachine.right_head_type}</p>
              </div>
              <div>
                <label>Brand</label>
                <p>{selectedMachine.brand}</p>
              </div>

              <div>
                <label>Model</label>
                <p>{selectedMachine.model}</p>
              </div>

              <div>
                <label>No Of Heads</label>
                <p>{selectedMachine.NoOfHeads}</p>
              </div>

              <div>
                <label>NO Of Needles</label>
                <p>{selectedMachine.NoOfNeedls}</p>
              </div>
              <div>
                <label>Max Sewing Speed(RPM)</label>
                <p>{selectedMachine.Maxsewingspeed}</p>
              </div>
              <div>
                <label>Beam Body Size (MM)</label>
                <p>{selectedMachine.beamBody}</p>
              </div>

              <div>
                <label>Motor</label>
                <p>{selectedMachine.motor}</p>
              </div>

              <div>
                <label>Usb Port</label>
                <p>{selectedMachine.usbport}</p>
              </div>
              <div>
                <label>Machine Age</label>
                <p>{selectedMachine.machine_old}</p>
              </div>
              <div>
                <label>Price(Rs)</label>
                <p>₹ {selectedMachine.price}</p>
              </div>

              <div>
                <label>Status</label>
                <p>{selectedMachine.status}</p>
              </div>

              <div>
                <label>City</label>
                <p>{selectedMachine.city}</p>
              </div>

              <div>
                <label>Seller</label>
                <p>
                  {selectedMachine.name} ({selectedMachine.phone})
                </p>
              </div>

              <div>
                <label>Location</label>
                <p>
                  {selectedMachine.location}, {selectedMachine.city},{" "}
                  {selectedMachine.state}
                </p>
              </div>
              <div>
                <label>Ads Duration</label>
                <p>{selectedMachine.show_ads_days}</p>
              </div>

              <div>
                <label>Payed Amount</label>
                <p>{selectedMachine.ads_amount}</p>
              </div>

              {selectedMachine.payment_screenshot && (
                <div className="payment-proof-section">
                  <label>Payment Screenshot</label>

                  <div
                    className="popup-images"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setPaymentImage(
                        `${UPLOADS.PAYMENT_SCREENSHOT}${selectedMachine.payment_screenshot}`,
                      );
                      setShowPaymentModal(true);
                    }}
                  >
                    <img
                      src={`${UPLOADS.PAYMENT_SCREENSHOT}${selectedMachine.payment_screenshot}`}
                      alt="payment"
                      className="payment-thumb"
                    />
                  </div>
                </div>
              )}
            </div>
            {/* PAYMENT IMAGE MODAL */}
            {showPaymentModal && (
              <div
                className="image-modal-overlay"
                onClick={() => setShowPaymentModal(false)}
              >
                <div
                  className="image-modal-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    className="image-close-btn"
                    onClick={() => setShowPaymentModal(false)}
                  >
                    ✖
                  </button>

                  <img
                    src={paymentImage}
                    alt="Payment Full"
                    className="full-payment-image"
                  />
                </div>
              </div>
            )}

            <div className="description-box">
              <label>Description</label>
              <p>{selectedMachine.description}</p>
            </div>

            <div className="popup-images">
              {selectedMachine.image &&
                selectedMachine.image
                  .split(",")
                  .map((img, i) => (
                    <img
                      key={i}
                      src={`${UPLOADS.MACHINE_IMAGE}${img}`}
                      alt="machine"
                    />
                  ))}
            </div>

            <div className="modal-actions">
              {/* <button
                className="btn btn-success"
                onClick={() => handleStatus("Active")}
              >
                Accept
              </button> */}

              <button
                className="btn btn-warning"
                onClick={() => handleStatus("Hide")}
              >
                Hide
              </button>

              <button
                className="btn btn-danger"
                onClick={() => handleStatus("Rejected")}
              >
                Reject & Delete
              </button>

              <button className="btn btn-secondary" onClick={handleClose}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
